import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';
export const API = `${BACKEND_URL}/api`;

export const getAvatarUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_URL}${url}`;
};

const api = axios.create({ baseURL: API, withCredentials: true }); // Force recompile

api.interceptors.request.use((config) => {
  const t = localStorage.getItem('tm_jwt');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errCode = error.response.data?.error;
      if (errCode !== 'pending_approval' && errCode !== 'rejected') {
        localStorage.removeItem('tm_jwt');
        // If we are not already on the login or signup page, redirect to login
        if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signup')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
